import React from "react";
import ImageGallery from "../components/ImageGallery";
import useGalleryImages from "../hooks/useGalleryImages";

export default function Gallery() {
  const { images, loading, error } = useGalleryImages();

  return (
    <div className="max-w-7xl mx-auto px-4 py-12 bg-white dark:bg-gray-900">
      <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800 dark:text-gray-100 mb-10">
        Project Gallery
      </h1>
      {loading && <p className="text-center text-gray-500">Loading gallery…</p>}
      {error && <p className="text-center text-red-600">{error}</p>}
      {!loading && !error && images.length === 0 && (
        <p className="text-center text-gray-500">No gallery items have been published yet.</p>
      )}
      {!loading && !error && <ImageGallery images={images} />}
    </div>
  );
}
